var React = require('react');

function SocialLinked (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"fill":"#007BB5","height":"23","width":"7","y":"9","key":0}),React.createElement("path",{"d":"M24.003,9C20,9,18.89,10.312,18,12V9h-7v23h7V19c0-2,0-4,3.5-4s3.5,2,3.5,4v13h7V19C32,13,31,9,24.003,9z","fill":"#007BB5","key":1}),React.createElement("circle",{"cx":"3.5","cy":"3.5","fill":"#007BB5","r":"3.5","key":2})]));
}

SocialLinked.defaultProps = {"enableBackground":"new 0 0 32 32","height":"32px","version":"1.0","viewBox":"0 0 32 32","width":"32px","xmlSpace":"preserve"};

module.exports = SocialLinked;

SocialLinked.default = SocialLinked;
